import { handleActions } from 'redux-actions'
import { ListView } from 'antd-mobile-v2'
import { SET_HOME_PRODUCTS_DATA, SET_HOME_PRODUCTS_STATE } from '../constants/mallConstant'
import { handleStateChange } from '../utils'

let initState = {
  loading: false,
  errorMessage: false,
  pageIndex: 1,
  isLastPage: false,
  data: [],
  dataSource: (new ListView.DataSource({ rowHasChanged: (row1, row2) => row1 !== row2 }))
}

export let mallHomeProducts = handleActions({
  [SET_HOME_PRODUCTS_STATE]: handleStateChange,
  [SET_HOME_PRODUCTS_DATA]: (state, action) => {
    // todo keymap
    let { list, isLastPage, pageNum: pageIndex } = action.payload
    let data = pageIndex === 1 ? list : [...state.data, ...list]
    let dataSource = new ListView.DataSource({ rowHasChanged: (row1, row2) => row1 !== row2 })
    return {
      loading: false,
      errorMessage: '',
      pageIndex,
      isLastPage,
      data,
      dataSource: dataSource.cloneWithRows(data)
    }
  }
}, initState)
